import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectStaticText } from 'components/StaticText/connect'
import { connect as connectRedux } from 'react-redux'
import { H1, H2, HEADING_TYPES } from 'components/Heading'
import Button, { TYPES } from 'components/Button'
import Link from 'components/Link'
import GaiaLogo, { TYPE_WHITE } from 'components/GaiaLogo'
import {
  URL_LOGOUT,
  URL_PLAN_SELECTION_PLANS,
  URL_MARKETPLACE_LOGGED_IN,
  URL_PLAYLIST_PURCHASES_VIDEOS,
} from 'services/url/constants'
import { getPrimary } from 'services/languages'
import { EN } from 'services/languages/constants'
import { getUserName } from 'services/user'
import _get from 'lodash/get'
import { get as getConfig } from 'config'

const config = getConfig()
const purchaseOnlyUserFlowActive = !!_get(config, ['features', 'purchaseOnlyUserFlow'])

const ModalCartAbandonV2 = ({
  user,
  staticText,
}) => {
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const userName = getUserName(user.get('data'))
  const purchasesUrl = purchaseOnlyUserFlowActive
    ? URL_PLAYLIST_PURCHASES_VIDEOS
    : `${URL_MARKETPLACE_LOGGED_IN}?redirect=my-stuff `

  return (
    <div className="modal-cart-abandon-v2">
      <div className="modal-cart-abandon-v2__wrapper">
        <header className="modal-cart-abandon-v2__header">
          <GaiaLogo
            type={TYPE_WHITE}
            className={['modal-cart-abandon-v2__gaia-logo']}
            isHref={false}
          />
          <Link
            className="modal-cart-abandon-v2__sign-out"
            to={URL_LOGOUT}
            scrollToTop
          >
            {staticText.getIn(['data', 'signOut'])}
          </Link>
        </header>
        <div className="modal-cart-abandon-v2__content-wrapper">
          <div className="modal-cart-abandon-v2__content">
            <H1
              as={HEADING_TYPES.H6}
              className="modal-cart-abandon-v2__title"
              inverted
            >
              {`${staticText.getIn(['data', 'welcomeBack'])}, ${userName}!`}
            </H1>
            <H2
              as={HEADING_TYPES.H4}
              className="modal-cart-abandon-v2__subtitle"
              inverted
            >
              {staticText.getIn(['data', 'watchAccessDescription'])}
            </H2>
            <Button
              className="modal-cart-abandon-v2__button"
              type={TYPES.PRIMARY}
              url={URL_PLAN_SELECTION_PLANS}
              scrollToTop
            >
              {staticText.getIn(['data', 'startFreeTrial'])}
            </Button>
          </div>
          {userLanguage === EN
            ? <div className="modal-cart-abandon-v2__content">
              <H2
                as={HEADING_TYPES.H5}
                className="modal-cart-abandon-v2__title-marketplace"
                inverted
              >
                {staticText.getIn(['data', 'contentFromMarketPlace'])}
              </H2>
              <Button
                className="modal-cart-abandon-v2__button"
                type={TYPES.SECONDARY}
                url={purchasesUrl}
                scrollToTop
                inverted
                directLink
              >
                {staticText.getIn(['data', 'viewPurchasedContent'])}
              </Button>
            </div>
            : null}
        </div>
      </div>
    </div>
  )
}

ModalCartAbandonV2.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'modalCartAbandonV2' }),
  connectRedux(
    (state) => ({
      user: state.user,
    }),
  ),
)(ModalCartAbandonV2)
